import React from 'react';
import { useParams } from 'react-router-dom';
import ParentDashboard from '../domains/parent/components/ParentDashboard';

const AdminParentPreviewPage: React.FC = () => {
  const { parentId } = useParams<{ parentId: string }>();
  if (!parentId) return <div style={{ padding: 16 }}>Missing parentId.</div>;
  return <ParentDashboard adminParentIdOverride={parentId} />;
};

export default AdminParentPreviewPage;

